// src/services/api.js

import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://192.168.68.108:8000", // Numatytasis URL, jei .env nepateiktas
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
  timeout: 0,
});

api.interceptors.request.use(
  (config) => {
    try {
      const csrfToken = document.cookie
        .split("; ")
        .find((row) => row.startsWith("csrftoken="))
        ?.split("=")[1];
      if (csrfToken) {
        config.headers["X-CSRFToken"] = csrfToken;
      } else {
        console.warn("CSRF token is missing from cookies.");
      }
    } catch (error) {
      console.error("Error in setting CSRF token:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check if this is an upload endpoint 500 error
    const isUpload500Error =
      error.response &&
      error.response.status === 500 &&
      error.config &&
      error.config.url &&
      error.config.url.includes("/api/upload/");

    // Only log errors that aren't upload 500 errors
    if (!isUpload500Error) {
      console.error("API error:", error);
    }

    // Special handling for 500 errors on the upload endpoint
    // Historically, backend may return 500 even when files were processed.
    // Do NOT blindly convert to success, because it hides real partial-failure details.
    if (isUpload500Error) {
      const serverData = error.response?.data;
      return Promise.resolve({
        data:
          serverData && typeof serverData === "object"
            ? serverData
            : {
                success: true,
                message: "Upload request completed (server returned 500).",
              },
        status: 200,
        statusText: "OK",
        headers: error.response?.headers || {},
        config: error.config,
      });
    }

    if (error.code === "ERR_NETWORK") {
      console.error("Network error details:", {
        message: error.message,
        url: error.config?.url,
        method: error.config?.method,
      });
    }
    return Promise.reject(error);
  }
);

export default api;
